/* ------------------------------------*\
    VARIABLE DECLARATION
\*------------------------------------*/

$(window).on('load', () => {
    /*------------------------------------*\
        CALL TO FUNCTIONS
    \*------------------------------------*/


    if (isHome()) {
        console.log(
            '<!-- ----------------------------------------------------- -->\n' +
        '<!-- Home -->\n' +
        '<!-- ----------------------------------------------------- -->');
        setupHome();
    } else {
        //
    }

});

/*------------------------------------*\
HOME
\*------------------------------------*/
function setupHome() {
    //specific for mobile
    if(deviceDetector.device == 'desktop'){
        // You're on a desktop.
        // console.log('desktop');

    }else{
        if(deviceDetector.device == 'tablet'){
            // You're on a tablet.
            // console.log('tablet');
        }else{
            // console.log('phone');
        }
        // You're on a phone.
    }
    setupMarquee();

    setupButtonsWithVariants();

    setupGSAP();

    checkCookieBox();
    // setupAdWordsOnclick();
}

function setupMarquee(){
    Marquee3k.init({
        selector: 'marquee3k', // define a custom classname
    });
    setTimeout(function(){
        $('#p-front-page-marquee_01').addClass('active');
        $('.footer-row-sticky').addClass('active');
    },500);
}

function setupAdWordsOnclick(){
    const $buttons = $('#single_add_to_cart_button');

    $buttons.on('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        gtag_report_conversion($(this).attr('href'),$(this).attr('data-price'));
    });
}

function setupButtonsWithVariants(){
    const $radio_buttons = $('.subcription-button-variable-options-option');

    //SETUP THE SELECTION
    $radio_buttons.each(function(){
        if($(this).is(':checked')){
            $(this).parent().parent().find('a').attr('href',$(this).next().attr('data-link'));
            $(this).parent().parent().find('a').attr('data-price',$(this).attr('data-price'));
        }
    });

    //LISTEN FOR EVENTS
    $radio_buttons.change(function() {
        $(this).parent().parent().find('a').attr('href',$(this).next().attr('data-link'));
        $(this).parent().parent().find('a').attr('data-price',$(this).attr('data-price'));

    });


}

function setupGSAP(){
    var tl = gsap.timeline();
    // tl.staggerTo(wrf_title, 1, {opacity: 1, stagger: 0.2});
    // tl.to('#svg_00_svg_logo_title',
    //  {rotate: 360,  duration: 10, ease: Linear.easeNone});
    tl.to('#svg_00_svg_logo_title',1, {opacity: 1})
    tl.to('#svg_00_svg_logo_TNWC-Logo',1, {opacity: 1},'<')
    // tl.to('#svg_00_svg_logo_title',20,{rotation:360,transformOrigin:"50% 50%",ease:Linear.easeNone}, "<");
    var tl2 = gsap.timeline({repeat:-1});
    tl2.to('#svg_00_svg_logo_title',30,{rotation:-360,transformOrigin:"50% 50%",ease:Linear.easeNone});
}

function checkCookieBox(){
    const $cookie = Cookies.get('c_box_closed');
    if( $cookie != 'set'){
        Cookies.set('c_box_closed', 'set', { expires: 7 });
        if(deviceDetector.device != 'desktop'){
            setTimeout(function(){
                $('.cookie_box').addClass('active');
                $('.cookie_box_close').on('click',function(){
                    $('.cookie_box').removeClass('active');
                });
            },3000);
        }else{
            setTimeout(function(){
                $('.cookie_box').addClass('active');
                $('.cookie_box_close').on('click',function(){
                    $('.cookie_box').removeClass('active');
                });
            },2000);
        }
    }

}

/*------------------------------------*\
jQuery Events
\*------------------------------------*/
$(window).on('scroll', function () {

});


/*------------------------------------*\
Extra methods
\*------------------------------------*/
